import { Branch, createBranch, convertUnixToDate } from '@golden/gdk-base';
import getUnixTime from 'date-fns/getUnixTime';
import { map, Observable } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
export function createAlertService(api, trunk) {
    const getRecentAlerts = () => {
        return new Observable();
    };
    return {
        recentAlerts: createBranch({
            trunk,
            branch: Branch.ADMIN_ALERT_RECENT,
            value: [],
            operator: () => getRecentAlerts()
        }),
        getAlertList(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_ALERT_LIST, { data })
                .pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'created_at')
                }))
            })));
        }
    };
}
//# sourceMappingURL=AlertService.js.map